import React, { FC } from "react";
import styles from "./sectionOne.module.scss";

const sectionOne: FC = () => {
  return (
    <div className={`${styles["main-container"]} container-fluid`}>
      <div className="main-box">
        <div className="section col-12 col-md-4">
          <img
            className="backgroundImgs"
            src="/assets/images/home/power-source/sectionOne/solar-bg.png"
            alt="backgroundImg"
          />

          <div className="title_box">
            <img
              className="icons"
              src="/assets/images/home/power-source/sectionOne/solar-icon.png"
              alt="icons"
            />
            <div className="text_box">
              <div className="title">太陽光能</div>
              <div className="subTitle">SOLAR</div>
            </div>
          </div>

          <div className="data_box">
            <div className="data">
              <div className="data_title">年發電量</div>
              <div className="data_number">180,000,000 kWh</div>
            </div>
            <div className="data middle">
              <div className="data_title">已售發電量</div>
              <div className="data_number">60,000,000 kWh</div>
            </div>
            <div className="data">
              <div className="data_title">已產生憑證</div>
              <div className="data_number">0 張</div>
            </div>
          </div>
        </div>
        <div className="section col-12 col-md-4">
          <img
            className="backgroundImgs"
            src="/assets/images/home/power-source/sectionOne/wind-bg.png"
            alt="backgroundImg"
          />
          <div className="title_box">
            <img
              className="icons"
              src="/assets/images/home/power-source/sectionOne/wind-icon.png"
              alt="icons"
            />
            <div className="text_box">
              <div className="title">風能</div>
              <div className="subTitle">WIND</div>
            </div>
          </div>

          <div className="data_box">
            <div className="data">
              <div className="data_title">在售年量能</div>
              <div className="data_number">接洽中</div>
            </div>
            <div className="data middle">
              <div className="data_title">已轉供交易電量</div>
              <div className="data_number">接洽中</div>
            </div>
            <div className="data">
              <div className="data_title">已產生憑證</div>
              <div className="data_number">接洽中</div>
            </div>
          </div>
        </div>
        <div className="section col-12 col-md-4">
          <img
            className="backgroundImgs"
            src="/assets/images/home/power-source/sectionOne/water-bg.png"
            alt="backgroundImg"
          />
          <div className="title_box">
            <img
              className="icons"
              src="/assets/images/home/power-source/sectionOne/water-icon.png"
              alt="icons"
            />
            <div className="text_box">
              <div className="title">水力</div>
              <div className="subTitle">WATER</div>
            </div>
          </div>

          <div className="data_box">
            <div className="data">
              <div className="data_title">在售年發電量</div>
              <div className="data_number">接洽中</div>
            </div>
            <div className="data middle">
              <div className="data_title">已轉供交易電量</div>
              <div className="data_number">接洽中</div>
            </div>
            <div className="data">
              <div className="data_title">已產生憑證</div>
              <div className="data_number">接洽中</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default sectionOne;
